import { Block, Spacer, Video, Spotify } from "../../../../src/components/project/project";
import * as React from 'react';
export default {
  Block,
  Spacer,
  Video,
  Spotify,
  React
};